<!--
 * @Author: guozhenqiang 15138913894@163.com
 * @Date: 2023-03-01 17:39:18
 * @LastEditors: guozhenqiang 15138913894@163.com
 * @LastEditTime: 2023-05-11 11:47:32
 * @FilePath: \baichuan-website\src\component\nav.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<!-- banner图 -->
<template>
     <div class="banner_box_new">
      <img loading="lazy" class="bg_img" :src="bgImg" />
      <div class="banner_t_content">
        <div class="banner_content" :style="{color: color}">
          <div class="banner_title">{{ bgTitle }}</div>
          <div class="banner_desc" >
            <p v-for="item in bgSubTitle.includes('/n') ?  bgSubTitle.split('/n') : [bgSubTitle]" :key="item">
              {{ item }}
            </p>
          </div>
        </div>
      </div>

    </div>
</template>
<script>
// import { color } from 'echarts/lib/export';
import { getEnglishWebsiteImg,getWebsiteImg } from "../request/api";
export default {
  props: {
    pageType: String,
    color:String,
    language:String,
  },
  data() {
    return {
      bgImg: '',
      // bgImg: "https://huahua-cdn.17huahua.cn/huala-management-front/166959921516944.png",
      bgTitle: "",
      bgSubTitle: "",
    };
  },
  created() {
    this.getBanner(this.pageType);
  },
  methods: {
    getBanner(pageType = 10) {
      if (this.language) {
        getEnglishWebsiteImg({
          pageType
        }).then(res => {
          if (res.code === 200) {
            this.bgImg =
              res.data.pageImage ||
              "https://huahua-cdn.17huahua.cn/huala-management-front/166959921516944.png";
            this.bgTitle = res.data.pageTitle;
            this.bgSubTitle = res.data.pageSubtitle|| '';
          }
        });
      } else {
        getWebsiteImg({
          pageType
        }).then(res => {
          if (res.code === 200) {
            this.bgImg =
              res.data.pageImage ||
              "https://huahua-cdn.17huahua.cn/huala-management-front/166959921516944.png";
            this.bgTitle = res.data.pageTitle;
            this.bgSubTitle = res.data.pageSubtitle|| '';
          }
        });
      }
    },
  }
};
</script>
<style scoped>
.banner_box_new {
  width: 100%;
  height: 400px;
  object-fit: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  background: #fff;
}
@media screen and (max-width:1200px) {
  .banner_box_new {
    width: 1200px;
  }
}
.bg_img {
  width: 100%;
  height: 100%;
}
.banner_t_content{
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.banner_content {
  width: 1200px;
  margin: 104px auto;

  z-index: 2;
  color: #333;

  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: justify;
  color: #333333;
}
.banner_title {
  font-size: 36px;
}
.banner_desc {
  font-size: 14px;
  line-height: 24px;
  margin-top: 29px;
}
</style>




// WEBPACK FOOTER //
// src/component/banner.vue